































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import dialogComp from "../index.vue";
import { Button } from "mint-ui";
import squareComp from "@/components/square/index.vue";
import { lottery } from "@/api/main";
import loginDialog from "@/components/dialog/login/index";
import gift from "./gift.vue";
@Component<Square>({
  components: {
    dialogComp,
    squareComp,
    gift,
    "mt-button": Button,
  },
})
export default class Square extends Vue {
  public prizeCode: string = "";
  public show() {
    (this.$refs.dialog as any).show();
  }
  public goUrl(){
    window._hmt.push(["_trackPageview", "/#/getPrize"]);
    location.href = 'https://event.qunar.com/qm/qunargiftnew/index.htm?activityNo=tongyongh5&bdsource=tongyong'
  }
}
